import React, { Fragment, useCallback, useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import {
  Divider,
  Grid,
  Typography,
} from '@material-ui/core';
import GenericModal, { IGenericModalProps } from 'components/GenericModal/GenericModal';
import ProgressBar from 'components/ProgressBar/ProgressBar';
import { modalsActionsClose } from 'store/modules/ModalsActions';
import { IModalProps } from 'store/modules/ModalsReducer';
import useStyle from './style';
import { IAssembleiaResultadosVotos } from 'store/modules/AssembleiasAssessorReducer';
import { toFixedPercentage } from 'utils/Number';
import { assembleiasAssessorResultadosVotos } from 'store/modules/AssembleiasAssessorActions';
import AxiosErrorHandler from 'utils/AxiosErrorHandler';
import { assembleiasAssociadoResultadosVotos } from 'store/modules/AssembleiasAssociadoActions';

export interface ResultadosModalProps extends IGenericModalProps {
  key: string;
  idPauta: number;
  flgAssessor: boolean;
}

interface Props extends IModalProps {
  genericProps: ResultadosModalProps;
}

export default function ({ genericProps }: Props) {
  const { t } = useTranslation();
  const classes = useStyle();
  const dispatch = useDispatch();
  const [resultadoPauta, setResultadoPauta ] = useState<IAssembleiaResultadosVotos>();

  const handleClose = useCallback(() => {
    dispatch(modalsActionsClose(genericProps.key));
  }, [dispatch, genericProps]);

  useMemo(() => {
    if(resultadoPauta && resultadoPauta.resultado !== undefined && resultadoPauta.resultado?.length!){
     resultadoPauta.resultado.sort((itemA, itemB): number => {
              return itemB.porcentagem - itemA.porcentagem;
            });
    }
  }, [resultadoPauta])

  const buscarResultadosPautaAssessor = useCallback(() => {
    dispatch(
      assembleiasAssessorResultadosVotos(
        genericProps.idPauta,
        (resp) => {
          setResultadoPauta(resp);
        },
        error => {
          AxiosErrorHandler(error);
        }
      )
    );
  },[dispatch, genericProps]);

  const buscarResultadosPautaAssociado = useCallback(() => {
    dispatch(
      assembleiasAssociadoResultadosVotos(
        genericProps.idPauta,
        (resp) => {
          setResultadoPauta(resp);
        },
        () => {
          
        }
      )
    );
  },[dispatch, genericProps]);

  useEffect(() => {
    genericProps.flgAssessor ? buscarResultadosPautaAssessor() : buscarResultadosPautaAssociado();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genericProps]);

  return (
    <GenericModal
      title={resultadoPauta?.tituloTipoAssembleia}
      genericProps={{
        maxWidth: 'sm',
        onClose: handleClose,
        DialogContentProps: {
          className: classes.root,
        },
      }}
      content={
        <React.Fragment>
          <Fragment>
            <Typography component="p" className={classes.title}>
              {resultadoPauta?.tituloPauta}
            </Typography>
            <Divider />
            {
              resultadoPauta && resultadoPauta.resultado !== undefined && resultadoPauta.resultado?.length! ? 
              resultadoPauta?.resultado
              .map(item => (
                <Grid key={item.idItemPauta} container className={classes.item}>
                    <Grid item xs={6} sm={6}>
                      <Typography className={classes.itemText}>
                        <strong>{item.descricao}</strong>
                      </Typography>
                    </Grid>
                    <Grid item xs={3} sm={6}>
                      <Typography className={classes.itemPerc}>
                        {t('ResultadoModal.dados', {
                          porcentagem: toFixedPercentage(item.porcentagem).toString().replace('.', ','),
                          count: item.cotas
                        })}
                      </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.itemProgress}>
                      <ProgressBar genericProps={{ percent: item.porcentagem > 100 ? 100 : item.porcentagem }} />
                    </Grid>
                  </Grid>
              ) ) : null
            }
            {
              resultadoPauta?.mensagemResultado && (
                <Grid xs={12}>
                  <Typography className={classes.paddingTop}>
                    {resultadoPauta.mensagemResultado}
                  </Typography>
                </Grid>
              )
            }
          </Fragment>
        </React.Fragment>
      }
    />
  );
}
